import React from "react";

const Timer = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M24.095 17.356H21.81V23.4l4.571 3.022 1.143-1.858-3.429-2.297v-4.911zm-.762-5.29L2 3v10.578L15.714 16.6 2 19.622V30.2l11.078-4.7c1.25 4.443 5.364 7.722 10.255 7.722C29.215 33.222 34 28.477 34 22.644c0-5.832-4.785-10.577-10.667-10.577zm0 18.134c-4.19 0-7.588-3.355-7.619-7.51v-.106c.03-4.14 3.429-7.51 7.62-7.51 4.205 0 7.618 3.385 7.618 7.555 0 4.171-3.413 7.571-7.619 7.571z"
            fill={fill}
        />
    </svg>
);

export default Timer;
